import React, { Component } from "react";
//import { connect } from "react-redux";
import { Card } from "material-ui/Card";
import { Flex, Box } from "rebass";
import { translate } from "admin-on-rest";
import TextField from "material-ui/TextField";
import moment from "moment";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter,
} from "material-ui/Table";
import ContentCreate from "material-ui/svg-icons/content/create";
import ImageEye from "material-ui/svg-icons/image/remove-red-eye";
import { GET_LIST } from "admin-on-rest";
import { cyan500 } from "material-ui/styles/colors";
import { ViewTitle, Pagination, LinkButton } from "../components";
import { HeaderTitle, DivFormContainer } from "./styled";
import { RestClient } from "../restClient";
import { get } from "lodash";

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      textSearch: "",
      list: [],
      page: 1,
      totalPage: 0,
      perPage: 50,
    };
    // console.log(this.props.match);
    this.getAgencyMarketers(this.props.match.params, {});
  }

  getAgencyMarketers(params, filters) {
    const { perPage, page } = this.state;
    RestClient(GET_LIST, `agencyMarketers/${params.id}`, {
      pagination: { page: page, perPage: perPage },
      sort: { field: "first_name", order: "ASC" },
      filter: filters,
    })
      .then((items) => {
        if (items && items.data) {
          // console.log(items.data);
          this.setState({
            list: items.data,
            totalPage: items.total,
          });
        }
      })
      .catch((e) => {
        // resolve([]);
      });
  }
  setPage = (page) => {
    this.setState({
      page: 2,
    });
    this.getAgencyMarketers(this.props.match.params, {});
  };
  onSearch = (event, value) => {
    this.setState({
      textSearch: value,
    });
    setTimeout(this.onResultSearch.bind(this, value), 1000);
  };
  onResultSearch = (value) => {
    if (value === this.state.textSearch) {
      // console.log(value);
      const filters = { search: value };
      this.getAgencyMarketers(this.props.match.params, filters);
    }
  };
  render() {
    const { list, totalPage, perPage, page } = this.state;
    return (
      <Card containerStyle={{ minHeight: 318 }}>
        <ViewTitle title={<HeaderTitle {...this.props} />} />
        <DivFormContainer w={[1]}>
          <Flex w={[1]} justify={["flex-end"]} p={[1]}>
            <TextField
              hintText='Search...'
              onChange={this.onSearch.bind(this)}
            />
          </Flex>
          <Box w={[1]} p={[1]}>
            <Table selectable={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow style={styles.rowHeader}>
                  <TableHeaderColumn style={styles.titleHeader}>
                    Name
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.titleHeader}>
                    Email
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.titleHeader}>
                    Instagram
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.titleHeader}>
                    Created On
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    style={{ width: 110, paddingLeft: 10, paddingRight: 10 }}
                  />
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {list.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{get(row, "nickname", "")}</TableRowColumn>
                    <TableRowColumn>{get(row, "email", "")}</TableRowColumn>
                    <TableRowColumn>
                      {get(row, "social.instagram", "-")}
                    </TableRowColumn>
                    <TableRowColumn>
                      {row && row.created_at
                        ? moment(row.created_at).format("DD-MM-YYYY")
                        : ""}
                    </TableRowColumn>
                    <TableRowColumn style={{ textAlign: "right" }}>
                      <LinkButton
                        {...this.props}
                        icon={<ImageEye />}
                        style={{ textAlign: "right", width: 50 }}
                        urlPath={`/marketers/${row.id}/show`}
                      />
                      <LinkButton
                        {...this.props}
                        icon={<ContentCreate />}
                        style={{ textAlign: "right", width: 50 }}
                        urlPath={`${this.props.match.url}/${row.id}`}
                      />
                    </TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter adjustForCheckbox={false}>
                <TableRow>
                  <TableRowColumn colSpan='5' style={styles.rowFooter}>
                    <Pagination
                      page={page}
                      total={totalPage}
                      perPage={perPage}
                      setPage={this.setPage.bind(this)}
                    />
                  </TableRowColumn>
                </TableRow>
              </TableFooter>
            </Table>
          </Box>
        </DivFormContainer>
      </Card>
    );
  }
}

export default translate(UsersList);

const styles = {
  rowHeader: {
    backgroundColor: cyan500,
  },
  rowFooter: {
    // backgroundColor:   grey100,
    padding: "0px",
    width: "100%",
  },
  titleHeader: {
    color: "#FFFFFF",
    fontSize: "14px",
  },
};



// WEBPACK FOOTER //
// ./src/agency/UsersList.js